export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20epic%20illustration%20artwork%2C%20warm%20coral%20and%20cream%20atmosphere%2C%20dramatic%20fantasy%20scene%20with%20multiple%20characters%2C%20soft%20dreamy%20lighting%2C%20beautiful%20manhwa%20art%20style%2C%20rich%20warm%20toned%20background%20with%20gentle%20gradients%2C%20cinematic%20composition%2C%20clean%20korean%20comics%20aesthetic&width=1800&height=900&seq=hero-home-2026&orientation=landscape"
        alt="韩国漫画网 - 韩漫大全在线阅读"
        title="韩国免费漫画-韩漫大全-下拉式漫画全集在线阅读"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-white mb-4 md:mb-6 tracking-tight leading-tight">
          韩漫大全
          <span className="block text-xl md:text-2xl lg:text-3xl font-normal mt-2 md:mt-3 opacity-90">
            下拉式漫画全集在线阅读
          </span>
        </h1>
        <p className="text-sm md:text-base text-white/80 max-w-lg md:max-w-xl mb-6 md:mb-8 leading-relaxed">
          海量韩国漫画免费阅读 · 每日同步更新 · 分类清晰一触即达
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <a
            href="#featured"
            className="px-8 py-3 bg-primary-500 text-white text-sm font-semibold rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            热门推荐
          </a>
          <a
            href="#daily"
            className="px-8 py-3 bg-white/15 backdrop-blur-sm text-white text-sm font-semibold rounded-full hover:bg-white/25 transition-all whitespace-nowrap cursor-pointer border border-white/20"
          >
            今日更新
          </a>
        </div>
      </div>
    </section>
  );
}